export default {
  course: {
    index: 'adCollege_home',
    courseList: 'adCollege_course_center',
    courseDetail: 'course_content'
  }
};